<template>
  <div class="border rounded p-2">
    <h4 class="mb-1">
      {{ label }}
    </h4>
    <b-media
      no-body
      vertical-align="center"
      class="flex-column flex-md-row"
    >
      <b-media-aside>
        <video
          v-if="type === 'video' && src"
          ref="refVideo"
          width="170"
          controls
        >
          <source :src="src">
          Your browser does not support HTML5 video.
        </video>
        <b-img
          v-else-if="type === 'image'"
          :src="src"
          height="110"
          width="170"
          class="rounded mr-2 mb-1 mb-md-0"
        />
        <b-img
          v-else
          :src="src"
          height="110"
          width="170"
          class="rounded mr-2 mb-1 mb-md-0"
        />
      </b-media-aside>
      <b-media-body>
        <div class="d-inline-block">
          <b-form-file
            :id="id"
            v-model="selfValue"
            :accept="onlyAccept"
            :placeholder="placeholder"
            :state="state"
            @change="handleInput($event)"
          />
          <slot name="invalidFeedback" />
        </div>
      </b-media-body>
    </b-media>
    <b-form-group
      v-if="typeof alt !== 'undefined'"
      :label="$t('general.alt')"
      :label-for="`${id}-alt`"
      class="mt-2"
    >
      <b-form-input
        :id="`${id}-alt`"
        v-model="selfAlt"
      />
      <b-form-invalid
        :id="`${id}-alt-feedback`"
        :label="$t('general.alt')"
        :validator="altValidator"
        :is-bootstrap="false"
      />
    </b-form-group>
  </div>
</template>

<script>
import {
  BMedia, BMediaAside, BMediaBody, BImg, BFormFile, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import { ref } from '@vue/composition-api'

export default {
  name: 'BFileInput',
  components: {
    BMedia,
    BMediaAside,
    BMediaBody,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormInvalid,
  },
  props: {
    value: {
      type: [Object, File],
    },
    id: {
      type: [String, Number],
    },
    placeholder: {
      type: [String],
      default: 'انتخاب کنید',
    },
    state: {
      type: [Boolean],
    },
    label: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
    },
    type: {
      type: String,
      default: 'image',
    },
    altValidator: {
      type: [Object],
    },
  },
  setup() {
    const refVideo = ref(null)
    return {
      refVideo,
    }
  },
  data() {
    return {
      selfValue: null,
      imageObj: null,
      src: null,
      selfAlt: null,
    }
  },
  computed: {
    onlyAccept() {
      if (this.accept) return this.accept
      if (this.type === 'image') return '.jpg, .jpeg, .png'
      return ''
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val && val._id) {
          this.src = this.createFullFileAddress(val)
        }
      },
      immediate: true,
      deep: true,
    },
    selfValue(val) {
      this.$emit('input', val)
    },
    alt: {
      handler(val) {
        this.selfAlt = val
      },
      immediate: true,
    },
    selfAlt(val) {
      this.$emit('update:alt', val)
    },
  },
  methods: {
    uploadClientImage($event) {
      const [image] = $event.currentTarget.files
      this.imageObj = image
      this.src = URL.createObjectURL($event.currentTarget.files[0])
      if (this.type === 'video' && this.refVideo) {
        this.refVideo.load()
      }
    },
    handleInput($event) {
      this.uploadClientImage($event)
    },
    createFullFileAddress(file) {
      if (!file) return null

      // Handle the case where file might be a nested object with language keys
      const {
        baseUrl,
        bucketName,
        destination,
        filename,
      } = file
      return `${baseUrl + bucketName}/${destination}${filename}`
    },
  },
}
</script>
